import {Card, Progress, Col, Table, Divider, Typography, Row} from "antd";
import React from "react";
import ColoredTag from "../Tags/ColoredTag";
import {toRGB} from "../../utils/colorUtils";
import Logo from "../Graphics/Logo";


/**
 * Snapshot component is used to display the current symbols within a portfolio
 * @param snapshot {Array[Object]} - Array of objects containing the symbol and weight
 * @param categoryMapping {Object, optional} - Object mapping symbols to categories that can be colorized
 * @returns {JSX.Element}
 * @constructor
 */
const Snapshot = ({snapshot, categoryMapping, colorLookup, date})=>{
    const getColor = (key)=>{
        return categoryMapping?.[colorLookup?.[key]] || '#6E7B8B';
    }
    const columns = [
        {
            title: 'Symbol',
            dataIndex: 'key',
            key: 'key',
            render: (text, record)=>(
                <Typography.Text style={{color: getColor(record.key),  whiteSpace: 'nowrap', paddingLeft: 8}} ellipsis>
                    {snapshot.indexOf(record)+1}) {text==='custodial_cash' ? 'CASH': text.toUpperCase()}
                </Typography.Text>
            ),
            width: 100
        },
        { title: 'Weight (%)', dataIndex: 'wgt', key: 'wgt', render: (text, record)=>(
            record.wgt > 0 ? <Progress
                    status={'normal'}
                    strokeColor={getColor(record.key)}
                    percent={record.wgt*100}
                    format={(pct)=>`${pct.toFixed(0)}%`}
                    percentPosition={{
                        align: 'end',
                        type: 'outer'
                    }}
                    strokeLinecap={'butt'}
                    trailColor={'rgba(255, 255, 255, 0.2)'}
                    size={[100, 12]}

                /> : <span>-</span>
            )
        }
    ];



    return (
        <Card
            bordered={false}
            className={'gapless'}
            style={{padding: '5px'}}
        >
            {
                date && (
                    <Row align={'middle'} justify={'start'} gutter={8} className={'mb-5'}>
                        <Col>
                            <Logo src={'https://storage.googleapis.com/finiat-web-static-resources/icons/calendar-vector.jpeg'} height={'30px'} width={'30px'}/>
                        </Col>
                        <Col>
                            <Typography.Text style={{fontSize: '14px', fontWeight: '500'}}>{date}</Typography.Text>
                        </Col>
                    </Row>
                )}
            <div style={{padding: '0 15px'}}>
                <Row style={{marginBottom: 15}}>
                    {Object.keys(categoryMapping).map((key, idx)=>(
                        <ColoredTag width={60}
                                    name={key==='undefined'?"Alt":key}
                                    color={categoryMapping[key]} shadow={false}
                                    gradient={false}

                        />
                    ))}
                </Row>
                <Table className={' styled hide-scrollbar'}
                       dataSource={snapshot}
                       size={'middle'}
                       onRow={(record, rowIndex) => {
                           const color = getColor(record.key);
                           return {
                               style: {
                                   // background: `linear-gradient(to right, ${color}, ${stepHexColor(color, 10, -10)})`,
                                   background: `linear-gradient(to right, ${color}, ${toRGB(color, 0.7)} 4px, ${toRGB(color, 1)} 8px, ${toRGB(color, 0.5)} 8px, ${toRGB(color, 0)} 12px)`,
                                   zIndex: 100000,
                                   opacity: record.wgt > 0 ? 1: 0.3,
                                   color: "#000"


                               }
                           }
                       }}
                       columns={columns}
                       pagination={{pageSize: 20, hideOnSinglePage: true, position: 'bottomLeft'}}

                />
            </div>

        </Card>
    )
}

export default Snapshot